export default "__VITE_ASSET__ClA01wED__"